import React, {  useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Avatar, Box, Button, CardMedia, Checkbox, Container, CssBaseline, FormControlLabel, Typography } from "@material-ui/core";
import "./auth.css";
import { useDispatch } from "react-redux";
import { login } from "../../store/admin";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import useStyles from "./style";

const Login = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [generalError,setGeneralError] = useState('');
  const loginSchema = yup.object().shape({
    email: yup.string().email().required("Email could not be blank!"),
    password: yup.string().required("Password could not be blank!"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit =  (data: any) => {
    setGeneralError('');

    dispatch(login(data)).then((data:any)=>{
      if(data.error) {
        setGeneralError(data.payload.message);
      }
    })
  };

  return (
    <CardMedia image='/assets/images/doctorBg.jpg' className={classes.containerImage}>
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        className={classes.boxContainer}
      >
        <Avatar className={classes.firstAvater}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} className={classes.formBox}>
           <input className="form-control"  {...register("email")} placeholder="Email" />
           <p className="error">{errors.email?.message}</p>

           <input className="form-control"  {...register("password")} placeholder="Password" type="password" />
          <p className="error">{errors.password?.message}</p>
          <p className="error">{generalError}</p>
          
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.signIn}
          >
            Sign In
          </Button>
        </Box>
      </Box>
      <Copyright style={{ marginTop: 80, marginBottom: 40 }} />
    </Container>
    </CardMedia>
  );
};

const Copyright = (props: any) => {
    return (
      <Typography variant="body2" color="secondary" align="center" {...props}>
        {'Copyright © '}
        {'BDF Common User '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
export default Login;
